var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="sortable-list__item-container">\n  ';
 if (selection === "radio") { 
__p+='\n    <div class="custom-control custom-radio" data-radio-test-target="'+
((__t=( model.get('id') ))==null?'':__t)+
'">\n      <input class="custom-control-input" type="radio" '+
((__t=( model.get('disabled') ? "disabled" : "" ))==null?'':__t)+
' '+
((__t=( model.get('checked') ? "checked" : "" ))==null?'':__t)+
'>\n        <label class="custom-control-label"/>\n      </input>\n    </div>\n  ';
 } 
__p+='\n\n  <div class="sortable-list__item '+
((__t=( readOnly ? '' : 'sortable-list__item--active' ))==null?'':__t)+
'">\n    ';
 if (!readOnly) { 
__p+='\n      <i class="material-icons sortable-list__item-drag-handle">menu</i>\n    ';
 } 
__p+='\n\n    <span class="sortable-list__item-text">'+
((__t=( model.get('name') ))==null?'':__t)+
'</span>\n\n    ';
 if (model.get("warningContent")) { 
__p+='\n      <i data-mount="warning-content" class=\'material-icons sortable-list__warning\'>warning</i>\n    ';
 } 
__p+='\n  </div>\n\n  ';
 if (model.get("menu") && !readOnly) { 
__p+='\n    <span data-mount="menu" class="sortable-list__menu"></span>\n  ';
 } 
__p+='\n\n  ';
 if (badgeContent) { 
__p+='\n    <span class="sortable-list__badge">'+
((__t=( badgeContent ))==null?'':__t)+
'</span>\n  ';
 } 
__p+='\n</div>\n';
}
return __p;
};
